export default __webpack_public_path__ + "static/media/G0340.34I-26150_-17366_0.1666258680000.f63d2e74.jpg";